<div class="content-with-stepper-and-title">
    <main>
      <h1 id="generalTitle" class="sub-title offset-inline selfie-title" [innerHtml]="copyService.copies.occupation_title" *ngIf="!postLogin"></h1>
      <h1 id="generalTitle" class="sub-title offset-inline selfie-title" [innerHtml]="copyService.copies.occupation_update_title" *ngIf="postLogin"></h1>
      <div class="content-checkbox">
        <voxel-radio-button-group id="occupationsList">
          <voxel-radio-button *ngFor="let occupation of occupations" [id]="occupation.id" [checked]="occupation.checked" (radioButtonChange)="activeOccupation($event)" [value]="occupation.value">
            {{occupation.label}}
          </voxel-radio-button>
        </voxel-radio-button-group>
      </div>
      <div id="docIntroTitle" class="text"> {{ copyService.copies.occupation_sin }} </div>
    </main>
    <app-controls id="occupationBtns" [hasPrevious]="true" [back]="back" [nextLabel]="copyService.copies.form_contact_btn" [nextDisabled]="selectedOccupation.name == undefined" (only_previous)="sendBackButtonEvent()" (next)="next()"></app-controls>
  </div>
  